import { gql } from "@apollo/client";

const CHATCOUNTPERPAGEPERDAYSUBSCRIPTION = gql`
  subscription getdashboardchatcountperpage {
    getdashboardchatcountperpage {
      success
      error
      result
    }
  }
`;
export default CHATCOUNTPERPAGEPERDAYSUBSCRIPTION;
